__turbopack_context__.v({
  "grid-item": "index-module-scss-module__EtOZaq__grid-item",
  "grid-view": "index-module-scss-module__EtOZaq__grid-view",
  "hide-skeleton": "index-module-scss-module__EtOZaq__hide-skeleton",
  "recommender-widget": "index-module-scss-module__EtOZaq__recommender-widget",
  "title": "index-module-scss-module__EtOZaq__title",
});
